import { DEFAULT_ERROR_MESSAGE } from '@/constants'

export const getFirstErrorMessage = (error) => {
  if (error.response) {
    if (
      error.response?.data?.errors &&
      error.response?.data?.errors === Object(error.response?.data?.errors)
    ) {
      return arrayError(error.response.data.errors)
    } else if (error.response?.data?.message) {
      return error.response.data.message
    } else if (error.response?.data?.error) {
      if (error.response.data.error === Object(error.response.data.error)) {
        return arrayError(error.response.data.error)
      } else {
        return error.response.data.error
      }
    }
  }
  return DEFAULT_ERROR_MESSAGE
}

export const cleanSession = ($store, $router) => {
  $store.commit('auth/clearData')
  $router.push('/login')
}

const arrayError = (errors) => {
  const firstError = errors[Object.keys(errors)[0]]
  return Array.isArray(firstError) ? firstError[0] : firstError
}

export const formatter = new Intl.NumberFormat('es-MX', {
  style: 'currency',
  currency: 'MXN'
})

export const currencyFormat = {
  locale: 'es-MX',
  currency: 'MXN',
  currencyDisplay: 'symbol',
  valueRange: {
    min: 0,
    max: undefined
  },
  precision: undefined,
  hideCurrencySymbolOnFocus: true,
  hideGroupingSeparatorOnFocus: true,
  hideNegligibleDecimalDigitsOnFocus: false,
  autoDecimalDigits: false,
  exportValueAsInteger: false,
  autoSign: true,
  useGrouping: true
}

export const numberFormatter = new Intl.NumberFormat('es-MX')
export const groupBy = (xs, key) =>
  xs.reduce(function (rv, x) {
    ;(rv[x[key]] = rv[x[key]] || []).push(x)
    return rv
  }, {})
